var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRightTopArrow = function SvgRightTopArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#0F195A",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.166 22.832 11.137-11.137M15.41 11.168h7.424M22.833 18.59v-7.425"
  }))));
};
export { SvgRightTopArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzQiIGhlaWdodD0iMzQiIHZpZXdCb3g9IjAgMCAzNCAzNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9IkFycm93Ij4KPHBhdGggaWQ9IkxpbmUgMjIwIiBkPSJNMTEuMTY2IDIyLjgzMkwyMi4zMDI5IDExLjY5NTEiIHN0cm9rZT0iIzBGMTk1QSIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIvPgo8cGF0aCBpZD0iTGluZSAyMjEiIGQ9Ik0xNS40MDkyIDExLjE2OEgyMi44MzM4IiBzdHJva2U9IiMwRjE5NUEiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiLz4KPHBhdGggaWQ9IkxpbmUgMjIyIiBkPSJNMjIuODMzIDE4LjU4OThWMTEuMTY1MiIgc3Ryb2tlPSIjMEYxOTVBIiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIi8+CjwvZz4KPC9zdmc+Cg==";